import { USER } from '../constant/actionTypes';

const getUserSoftwareSubmodules = (state, action) => {
  switch (action.type) {
    case USER.SOFTWARE_SUBMODULES.INITIATE:
      return { isFetching: true };
    case USER.SOFTWARE_SUBMODULES.SUCCESS:
      return { isFetching: false, data: action.payload };
    case USER.SOFTWARE_SUBMODULES.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getUserSoftwareSubmodules;
